// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_t74is {
  overflow-x: auto;
  overflow-y: hidden;
  height: calc( 70vh - 121px);
}
.blueprintView_yCeux {
  height: 100%;
  overflow: hidden;
}
.childPathView_FECD3 {
  min-width: 200px;
}
.childPathView_FECD3 > input {
  width: 100%;
}
.blueprintList_dePkM {
  overflow-y: auto;
  margin-top: 30px;
}
.relationshipView_YErAB {
  height: 100%;
  overflow: scroll;
}
.addTypeButton_iuDU9 {
  min-width: 200px;
  text-align: center;
  user-select: none;
  padding: 8px;
}
.addTypeButton_iuDU9 > span {
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--light-grey);
}
.addTypeButton_iuDU9 > span > i.fa-arrow-right {
  font-size: 16px;
}
.addTypeButton_iuDU9 > span > i {
  margin: 8px 0;
}
.addTypeButton_iuDU9 > p {
  font-weight: 300;
  text-align: justify;
}
.addTypeButton_iuDU9:hover {
  background: var(--purple-5);
}
.addTypeButton_iuDU9:active {
  background: var(--purple-15);
}
.addTypeButton_iuDU9:hover span > i {
  color: var(--purple);
}
.dynamic_mSeGb {
  border: 1px solid var(--lighter-grey);
  max-width: 300px;
  align-self: flex-start;
  margin-top: 30px;
}
span.targetName_DdVzu,
span.sourceName_zHFqg {
  font-size: 14px;
  font-style: italic;
  color: var(--purple);
}
.buttons_z4Gml {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/screens/attribute/AddRelationshipDialog.css"],"names":[],"mappings":"AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb","sourcesContent":["@import \"../../style/theme.css\";\n.content {\n  overflow-x: auto;\n  overflow-y: hidden;\n  height: calc( 70vh - 121px);\n}\n.blueprintView {\n  height: 100%;\n  overflow: hidden;\n}\n.childPathView {\n  min-width: 200px;\n}\n.childPathView > input {\n  width: 100%;\n}\n.blueprintList {\n  overflow-y: auto;\n  margin-top: 30px;\n}\n.relationshipView {\n  height: 100%;\n  overflow: scroll;\n}\n.addTypeButton {\n  min-width: 200px;\n  text-align: center;\n  user-select: none;\n  padding: 8px;\n}\n.addTypeButton > span {\n  font-size: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--light-grey);\n}\n.addTypeButton > span > i:global(.fa-arrow-right ) {\n  font-size: 16px;\n}\n.addTypeButton > span > i {\n  margin: 8px 0;\n}\n.addTypeButton > p {\n  font-weight: 300;\n  text-align: justify;\n}\n.addTypeButton:hover {\n  background: var(--purple-5);\n}\n.addTypeButton:active {\n  background: var(--purple-15);\n}\n.addTypeButton:hover span > i {\n  color: var(--purple);\n}\n.dynamic {\n  border: 1px solid var(--lighter-grey);\n  max-width: 300px;\n  align-self: flex-start;\n  margin-top: 30px;\n}\nspan.targetName,\nspan.sourceName {\n  font-size: 14px;\n  font-style: italic;\n  color: var(--purple);\n}\n.buttons {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_t74is`,
	"blueprintView": `blueprintView_yCeux`,
	"childPathView": `childPathView_FECD3`,
	"blueprintList": `blueprintList_dePkM`,
	"relationshipView": `relationshipView_YErAB`,
	"addTypeButton": `addTypeButton_iuDU9`,
	"dynamic": `dynamic_mSeGb`,
	"targetName": `targetName_DdVzu`,
	"sourceName": `sourceName_zHFqg`,
	"buttons": `buttons_z4Gml`
};
export default ___CSS_LOADER_EXPORT___;
